import Cookies from 'js-cookie';
import store from '../../store/index';
import router from '@/router';

/**
 * Authentication middle ware to apply frontend checks
 * and redirection id the session exists or has expired.
 * 
 * @param {Function} next 
 * @param {Object} store
 * @returns {Function} 
 */
export default function auth ({ next, store }){
		
	if(store.getters.isAuthed) {
		return next();
	}

	if(!store.getters.isAuthed) {
		return next({name:'login'});
	}


}